<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="報告書商品明細別進捗管理一覧（建築・特健）"
    top="5vh"
    width="900px"
    :visible.sync="dialogVisible"
    append-to-body
    class="el_dialog"
    @close="close"
  >
    <vab-form ref="form" :model="formObject" :rules="rulesDay">
      <div class="flex_space margin_bottom_7 flex_align_end">
        <div class="flex_center_align">
          <div class="split_line"></div>
          <div class="box_title">PS課処理</div>
        </div>
        <vab-button :btn-list="btnListRt" />
      </div>

      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div>PS課→施設</div>
          </vab-col>
          <vab-col :span="20" class="word_box word_box_690 nopadding">
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <span class="clo_right_span">発送日</span>
                  <vab-date-picker
                    class="vab_picker margin_0"
                    type="date"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    prop="sendDateBeforeStamping"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <span class="clo_right_span">発送方法</span>
                  <div class="radio_box">
                    <vab-radio-group
                      ref="mailFlagRef"
                      class="margin_0"
                      prop="mailFlag"
                      filter="mailFlag"
                      :code-enum="$divisions.mailFlagEnum"
                    />
                  </div>
                  <vab-input
                    class="margin_0"
                    prop="letterPacknoBeforeStamping"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col
                :span="24"
                class="word_box word_box_imp"
                style="border: none"
              >
                <span class="clo_right_span textarea_span">
                  コメント（捺印前）
                </span>
                <vab-textarea
                  type="textarea"
                  prop="commentBeforeStamping"
                  rows="5"
                  class="vab_textarea clo_textarea"
                />
              </vab-col>
            </vab-row>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div>捺印返送日（返送）</div>
          </vab-col>
          <vab-col :span="20" class="word_box word_box_690 nopadding">
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <span class="clo_right_span">返送日</span>
                  <vab-date-picker
                    class="vab_picker margin_0"
                    type="date"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    prop="returnDateAfterStamping"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <span class="clo_right_span">返送方法</span>
                  <vab-input
                    label="レターパックNo"
                    prop="letterPacknoAfterStamping"
                    class="flex_center_align margin_0"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col
                :span="24"
                class="word_box word_box_imp"
                style="border: none"
              >
                <span class="clo_right_span textarea_span">
                  コメント（捺印後）
                </span>
                <vab-textarea
                  type="textarea"
                  prop="commentAfterStamping"
                  rows="5"
                  class="vab_textarea clo_textarea"
                />
              </vab-col>
            </vab-row>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div>PS課発送日（プラス）毎週水曜発送</div>
          </vab-col>
          <vab-col :span="20" class="word_box word_box_690 nopadding">
            <vab-row>
              <vab-col :span="24" class="word_box word_box_imp">
                <div class="flex_center_align">
                  <span class="clo_right_span">発送日</span>
                  <vab-date-picker
                    class="vab_picker margin_0"
                    type="date"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    prop="duplicateSendDate"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col
                :span="24"
                class="word_box word_box_imp"
                style="border: none"
              >
                <div class="flex_center_align">
                  <span class="clo_right_span">指摘</span>
                  <div class="radio_box">
                    <vab-radio-group
                      ref="refRadio"
                      class="margin_0"
                      prop="indicateFlag"
                      filter="indicateFlag"
                      :code-enum="$divisions.indicateFlagEnum"
                    />
                  </div>
                </div>
              </vab-col>
            </vab-row>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">済証（受領日）</vab-col>
          <vab-col :span="8" class="flex_center_align word_box word_box_265">
            <vab-date-picker
              class="vab_picker margin_0"
              type="date"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              prop="receiptDate"
            />
          </vab-col>
          <!--TODO 表里没有"協会提出日"字段 -->
          <vab-col :span="4" class="title_box">協会提出日</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <vab-date-picker
              class="vab_picker margin_0"
              type="date"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              prop="receiptDate"
            />
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">DLP→施設発送日</vab-col>
          <vab-col :span="8" class="flex_center_align word_box word_box_265">
            <vab-date-picker
              class="vab_picker margin_0"
              type="date"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              prop="dlpSendDate"
            />
          </vab-col>
          <!--TODO 表里没有"協会提出日"字段 -->
          <vab-col :span="4" class="title_box">北関返送状況</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <vab-radio-group
              ref="refRadio"
              class="margin_0"
              prop="northSendStatus"
              filter="northSendStatus"
              :code-enum="$divisions.northSendStatusEnum"
            />
          </vab-col>
        </vab-row>
      </div>
      <div style="margin: 17px 0 7px 0" class="flex_center_align">
        <div class="split_line"></div>
        <span class="box_title">作業情報</span>
      </div>
      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">作業名称</vab-col>
          <vab-col :span="8" class="flex_center_align word_box word_box_265">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.wrknm }}</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">発注No連番</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.acceptOrderNoSeq }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.blgsnmkj }}
              </div>
              <div class="sub_title">（建物CD：{{ formObject.blgscd }}）</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">管理形態</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.mngfrm }}</div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">協力会社</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.bcnfrkj }}</div>
              <div class="sub_title">
                （協力会社CD：{{ formObject.hcccd }}）
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">所属部門</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.orgkj }}</div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">作業予定日</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.wpdtmin }} ~ {{ formObject.wrkendpltm }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">作業実施日</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.wxdtmin }} ~ {{ formObject.wrkendtm }}
              </div>
            </div>
          </vab-col>
        </vab-row>
      </div>
      <div style="margin: 17px 0 6px 0" class="flex_center_align">
        <div class="split_line"></div>
        <span class="box_title">住居情報</span>
      </div>
      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">郵便番号</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.postno }}</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">管理員室TEL</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.mgotel }}</div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">組合名</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">{{ formObject.bcnfrkj1 }}</div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">住所</vab-col>
          <vab-col :span="8" class="word_box word_box_265 flex_center_align">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ formObject.adr1 }}
              </div>
            </div>
          </vab-col>
        </vab-row>

        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">個別対応</vab-col>
          <vab-col
            :span="20"
            class="word_box word_box_690 word_box_imp flex_center_align"
          >
            <vab-textarea
              type="textarea"
              prop="individualCorrespond"
              rows="5"
              class="vab_textarea"
            />
          </vab-col>
        </vab-row>
      </div>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <div class="cancel" @click="close">キャンセル</div>
        <vab-button :btn-list="btnList" />
      </div>
    </div>
    <PopupChildren
      :visible2="visibleChildren"
      :list="popChildrenList"
      :visible-children.sync="visibleChildren"
    />
  </el-dialog>
</template>

<script>
  export default {
    name: 'ReportPopupArchitecture',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formObject: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        btnListRt: [
          {
            name: ' 各種データダウンロード',
            widht: 'auto',
            icon: 'select',
            type: 'plain',
            hover: '#0071EE',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000446.name}`
            ),
            defaultColor: '#0060C2',
            hidden: false,
            click: () => {
              this.show()
            },
          },
        ],
        visibleChildren: false,
        dialogVisible: false,
        rulesDay: {},
        open: '2',
        columns: [
          {
            label: '氏名',
            'min-width': 228,
            prop: '',
          },
          {
            label: 'FM社員CD',
            'min-width': 120,
            prop: '',
          },
          {
            label: '職種名称',
            'min-width': 228,
            prop: '',
          },
          {
            label: '休日パターン',
            'min-width': 160,
            prop: '',
          },
          {
            label: '勤務時間',
            'min-width': 120,
            prop: '',
          },
        ],
        btnList: [
          {
            name: '更新',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: (row) => {
              console.log('???', row)
              // this.submitForm(row)
            },
          },
        ],
        value: '',
        options: [
          {
            value: '选项1',
            label: '黄金糕',
          },
          {
            value: '选项2',
            label: '双皮奶',
          },
        ],

        popChildrenList: [
          {
            title: 'PS課→施設',
            buttonList: [
              {
                name: ' 拠点発送レター',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' FM封筒',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
          {
            title: '捺印返送日（返送）',
            buttonList: [
              {
                name: ' 送付状（協力会社返送分）',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' 送付状（拠点用）',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
          {
            title: 'PS課発送日（プラス）毎週水曜発送',
            buttonList: [
              {
                name: ' プラスへの送付状',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' プラスにトラ一覧',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' プラス発送保管',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
          {
            title: 'その他',
            buttonList: [
              {
                name: ' レターパックNo一覧',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
        ],
      }
    },

    watch: {
      visible: function (val) {
        this.dialogVisible = val
      },
    },
    methods: {
      show() {
        this.visibleChildren = true
      },
      close() {
        this.dialogVisible = false
        this.$emit('update:visibleDay', false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  * {
    line-height: 150%;
  }
  .row_box {
    .vab_picker ::v-deep .el-input {
      width: 140px;
    }

    .vab_picker ::v-deep .el-form-item--mini.el-form-item {
      display: flex !important;
    }

    .clo_right_span {
      color: #000000;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      width: 70px;
      margin-right: 34px;
    }

    .clo_textarea {
      width: 563px;
      margin-left: 104px !important;
    }

    .textarea_span {
      padding-top: 8px;
      float: left;
    }
  }
  .el_dialog {
    ::v-deep .el-dialog__title {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #003350;
    }
    ::v-deep .el-dialog__header {
      padding: 12px;
    }
    ::v-deep .el-dialog__body {
      padding: 24px;
    }
    ::v-deep .el-dialog__headerbtn {
      top: 12px;
      font-size: 24px;
    }
  }

  .split_line {
    width: 4px;
    height: 20px;
    background: #003350;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .box_title {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #003350;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-left: 8px;
  }
  .margin_bottom_7 {
    margin-bottom: 7px;
  }

  .title_box {
    width: 160px;
  }

  .word_box_690 {
    width: 690px;
  }
  .word_box_imp {
    padding: 8px 12px !important;
  }
  .word_box_265 {
    width: 265px;
    padding: 8px 12px !important;
  }
  .flex_align_end {
    align-items: flex-end;
  }
  .vab_textarea {
    width: 100%;
    margin: 0 !important;
  }
  .margin_0 {
    margin: 0 !important;
  }
</style>
